import { FETCH_DASHBOARD_SUMMARY } from '../constants/actionTypes.js';
import * as api from '../api/index.js';

export const getDashboardSummary = () => async (dispatch) => {
  try {
    console.log('Fetching dashboard summary…');

    const { data } = await api.fetchDashboardSummary();

    dispatch({ type: FETCH_DASHBOARD_SUMMARY, payload: data });
    console.log('dashboard items fetched');
    

  } catch (error) {
    console.log(error.message);
  }
};
